// import dialingCodes from '../../../components/atoms/APSelect/reference/dialing_codes.json';
import {
    CLIENT_COUNTRY_CODE,
    DEFAULT_LANGUAGE,
    GREAT_BRITAIN_COUNTRY_CODE,
    UNITED_KINGDOM_COUNTRY_CODE,
    UNITED_KINGDOM_ISD_CODE,
    UNITED_KINGDOM_ISD_CODE_TEXT
} from '../../../core/utils/Constants/Constants';
import { GetCountriesDataWithDefaultLanguage, GetCountriesOptions, GetDialingCodeOptions } from '../../../core/utils/GetCountriesData';

type ReferenceData = {
    label: string;
    value: string;
    icon: string;
    displayName?: string;
};

export const getClientType = (clientTypes) => {
    const clientTypesArray = (clientTypes && clientTypes.length > 0) ? clientTypes.split(';') : [];
    const clientTypesObj = {
        personal: false,
        onlineMarketplaceSellers: false,
        corporate: false
    };
    clientTypesArray.forEach((clientType) => {
        switch (clientType.toLowerCase()) {
            case 'personal clients':
                clientTypesObj.personal = true;
                break;
            case 'online marketplace sellers':
                clientTypesObj.onlineMarketplaceSellers = true;
                break;
            case 'corporate clients':
                clientTypesObj.corporate = true;
                break;
            default:
                break;
        }
    });

    return clientTypesObj;
};

export const getSelectedClientLanguages = (clientData) => {
    let currentClientLanguages = (clientData && clientData?.client_Languages &&
        clientData.client_Languages.length > 0) ?
        (clientData.client_Languages.split(';')) : [];

    currentClientLanguages = currentClientLanguages.map((clientLanguage) => {
        return clientLanguage.toLowerCase();
    });

    return currentClientLanguages;
};

export const getSelectedCountries = (clientData) => {
    let currentClientCountries = (clientData && clientData?.client_Based_Countries &&
        clientData.client_Based_Countries.length > 0) ?
        (clientData.client_Based_Countries.split(';')) : [];

    currentClientCountries = currentClientCountries.map((clientCountry) => {
        return CLIENT_COUNTRY_CODE[clientCountry];
    });

    return currentClientCountries;
};

export const getSelectedIndustries = (clientData) => {
    let currentClientIndustries = (clientData && clientData?.client_Industry &&
        clientData.client_Industry.length > 0) ?
        (clientData.client_Industry.split(';')) : [];

    currentClientIndustries = currentClientIndustries.map((clientIndustry) => {
        return clientIndustry.toLowerCase();
    });

    return currentClientIndustries;
};

export const getSelectedEmailPreferences = (userData) => {
    let currentEmailPreferences: Array<string> = [];
    const allEmailPreferences = [
        "weekly_market_updates",
        "promotions",
        "product_news",
        "newsletters",
        "news_flash",
        "daily_update",
        "research_development",
    ];

    if (userData) {
        allEmailPreferences.forEach((emailPreference) => {
            userData[emailPreference] && currentEmailPreferences.push(emailPreference);
        });
    }

    return currentEmailPreferences;
};

export const addressCountryMapping = (addressCountry) => {
    const addressCountriesWithDefaultLanguage = GetCountriesDataWithDefaultLanguage();

    addressCountriesWithDefaultLanguage.options.forEach((option: ReferenceData) => {
        if (option.label === addressCountry || option.value === addressCountry) {
            addressCountry === UNITED_KINGDOM_COUNTRY_CODE ? addressCountry = GREAT_BRITAIN_COUNTRY_CODE : addressCountry = option.value;
        }
    });

    return addressCountry;
};

// Added to map for label rather than value in the countries.json
export const addressCountryLabelMapping = (addressCountry) => {
    const addressCountries = GetCountriesOptions();
    addressCountries.options.forEach((option: ReferenceData) => {
        if (option.label === addressCountry || option.value === addressCountry) {
            addressCountry = option.label;
        }
    });
    return addressCountry;
};

export const dialingCodeMapping = (isdCode) => {
    const dialingCodes = GetDialingCodeOptions('selectList');
    const userSelectedLanguage: string | null = localStorage.getItem('preferredLanguage') ?? DEFAULT_LANGUAGE;

    dialingCodes.options.forEach((option: ReferenceData) => {
        if (option.value === isdCode) {
            isdCode === UNITED_KINGDOM_ISD_CODE ? isdCode = UNITED_KINGDOM_ISD_CODE_TEXT[userSelectedLanguage] : isdCode = option.displayName;
        }
    });

    return isdCode;
};
